export const buildGeneratedValues = {
	timeStamp: 'Nov 5th 26, 09:48'
};
